import { useApp } from "../context";
import { money } from "../lib/engine";

export default function ExceptionEdit({ id }) {
  const { state, actions, closeModal } = useApp();
  const item = state.exceptions.find(e => e.id === id);
  if (!item) return null;
  return (
    <>
      <h2>{item.type}</h2>
      <p>{item.caseId} · {money(item.amount)}</p>
      <form data-testid="exception-form" onSubmit={e => actions.updateException(e, item.id)}>
        <div className="formgrid">
          <label>Owner
            <input name="owner" data-testid="exception-owner-input" defaultValue={item.owner} required maxLength={80} />
          </label>
          <label>Due date
            <input name="due" type="date" data-testid="exception-due-input" defaultValue={item.due} required />
          </label>
          <label className="full">Follow-up or resolution note
            <textarea name="note" rows={4} data-testid="exception-note-input" required maxLength={600} defaultValue={item.note} />
          </label>
          <label>Status
            <select name="status" data-testid="exception-status-select" defaultValue={item.status}>
              <option>Open</option>
              <option>Resolved</option>
            </select>
          </label>
        </div>
        <p className="notice space">
          Bank discrepancies cannot be marked resolved while commission remains outstanding.
          Resolution does not create a write-off.
        </p>
        <div className="footer">
          <button type="button" data-testid="exception-cancel-btn" onClick={closeModal}>Cancel</button>
          <button type="submit" className="primary" data-testid="exception-save-btn">Save changes</button>
        </div>
      </form>
    </>
  );
}
